<template>
  <div class="card">
    <slot />
  </div>
</template>

<script>
export default {
  name: "PricingCard",
};
</script>

<style lang="scss" >
@import "../styles/styles.scss";

.card {
  background: #fff;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 5.47px 13.68px rgba(0, 0, 0, 0.1);
  margin: 1em auto;
  min-width: 275px;
  width: 80%;
  .card-header {
    background: #0d0d0d;
    border-radius: 8px 8px 0 0;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    br {
      display: none;
    }
    h2 {
      font-size: 1.25em;
      color: #fff;
    }
  }
  .small-header {
    h2 {
      font-size: 1.125rem;
      font-weight: 400;
      padding: 0 2em;
    }
  }
  .card-content {
    p {
      font-size: 1em;
      letter-spacing: 0.82px;
      padding: 0.5em 1em;
      margin: 1em auto;
      color: #5d5d5d;
      font-weight: 400;
    }
    .light {
      font-weight: 300;
      color: #363636;
    }
    .sub-views {
      font-style: italic;
      font-size: 0.8em;
    }
  }
  hr {
    background-color: #e9e6e6;
    margin: 0em auto;
    height: 1px;
  }
  .card-price {
    font-size: 1.5em;
    padding: 1.5rem 0 0 0;
    font-weight: 500;
    color: #09100e;
  }
  p.card-price-p {
    font-size: 0.58em;
    padding: 0 0 1.5rem 0;
    margin: 0;
  }
}
</style>